import { IconUero5Max } from '@/components/layouts/header/icon-uero-5-max';
import { Icon } from '@/components/shared/element/icons';
import { Text } from '@/components/shared/element/text';
import { Box } from '@/components/shared/layout/box';
import { Image } from '@/components/shared/media/image';

interface MaintenanceListTableBriefImageTitleProps {
  showBadge: boolean;
  badgeText: string;
  imageSrc: string;
  showIconEuro5Max?: boolean;
}

export const MaintenanceListTableBriefImageTitle = (
  props: MaintenanceListTableBriefImageTitleProps
) => {
  return (
    <Box
      position="relative"
      data-test="maintenance_list_table_brief_image_title"
      paddingY={{ '@initial': '2', '@sm': '3' }}
    >
      <Box position="relative">
        <Box
          css={{
            maxWidth: 300,
            width: `${(300 / 360) * 100 + '%'}`,
            mx: 'auto',
            '@sm': {
              width: '100%',
            },
            '@md': {
              minWidth: 252,
              width: `${(300 / 528) * 100 + '%'}`,
            },
            '@lg': {
              minWidth: 'auto',
              width: 300,
            },
          }}
        >
          <Image
            src={props.imageSrc}
            alt="ISUZU"
            width={640}
            height={360}
            layout="responsive"
            objectFit="contain"
            sources={[
              {
                srcset: props.imageSrc,
                options: {
                  width: 300,
                },
              },
            ]}
          />
          {!!props.showIconEuro5Max && (
            <Box
              css={{
                width: 'calc(80 / 208 * 100%)',
                mx: 'auto',
                fontSize: 0,
                pointerEvents: 'none',
                '& svg': {
                  width: '100%',
                  height: 'auto',
                },
              }}
            >
              <IconUero5Max />
            </Box>
          )}
        </Box>
        {!!props.showBadge && (
          <Box
            data-test="maintenace_table_brief_badgeWarp"
            paddingY="1"
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap="2"
            css={{
              backgroundColor: '#F4FDF9',
            }}
          >
            <Icon icon="verified" color="icon-green-light" />
            <Text variant="text-green" size="text-body-1" font="bold">
              {props.badgeText}
            </Text>
          </Box>
        )}
      </Box>
    </Box>
  );
};

MaintenanceListTableBriefImageTitle.displayName =
  'SectionMaintenanceListTableBriefImageTitle';
